import { Switch } from '@headlessui/react'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  small?: boolean
}

export default function Toggle({ checked, onChange, small = false }: Props) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={`group inline-flex shrink-0 cursor-pointer items-center rounded-full bg-stone-300 transition-colors data-checked:bg-purple-700 data-disabled:cursor-not-allowed data-disabled:opacity-50 ${
        small ? 'h-4 w-7' : 'h-5 w-9'
      }`}
    >
      <span
        className={`translate-x-0.5 rounded-full bg-white shadow-sm transition-transform ${
          small ? 'size-3 group-data-checked:translate-x-3.5' : 'size-4 group-data-checked:translate-x-4.5'
        }`}
      />
    </Switch>
  )
}
